const { en: globalCommon } = require("../../common");
const { en: plasmidsCommon } = require("../../plasmids-page");

module.exports = {
	...globalCommon,
	...plasmidsCommon,
	"plasmids-plasmid": require("./plasmids-plasmid.json"),
	"section-try-for-free": require("../../section-try-for-free/en/section-try-for-free.json"),
};
